import { FontSize600, FontSize300, ButtonsSizeHeight } from "@nxt-costco-com/forge-design-tokens";
import { BORDER_RADIUS_CIRCLE, BORDER_RADIUS_STANDARD } from "./constants.js";
import { SkeletonVariant } from "./enums.js";
const singleElementVariants = {
  [SkeletonVariant.Button]: {
    height: ButtonsSizeHeight,
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.MultilineTextField]: {
    height: "64px",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.PillBadge]: {
    height: "24px",
    width: "48px",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.QuantitySelector]: {
    height: "40px",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.Rectangular]: {
    width: "100%",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.Select]: {
    height: "40px",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.SelectorCheckbox]: {
    height: "48px",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.SelectorRadioButton]: {
    height: "48px",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.TextBody]: {
    height: FontSize300,
    sx: { borderRadius: BORDER_RADIUS_CIRCLE }
  },
  [SkeletonVariant.TextField]: {
    height: "32px",
    sx: { borderRadius: BORDER_RADIUS_STANDARD }
  },
  [SkeletonVariant.TextHeader]: {
    height: FontSize600,
    sx: { borderRadius: BORDER_RADIUS_CIRCLE }
  }
};
export {
  singleElementVariants
};
